import React from "react";

export const PriorityPicker = ({ priority, setPriority, showPriority, setShowPriority, priorityRef }) => {
    const isConfigured = priority !== 4;

    const getPriorityStyles = () => {
        switch (priority) {
            case 1:
                return {
                    btn: "bg-red-50 border-red-300 text-red-700 font-semibold shadow-sm",
                    icon: "fas fa-flag text-red-600",
                    badge: "bg-red-600",
                    label: "Prioridad 1"
                };
            case 2:
                return {
                    btn: "bg-orange-50 border-orange-300 text-orange-700 font-semibold shadow-sm",
                    icon: "fas fa-flag text-orange-600",
                    badge: "bg-orange-600",
                    label: "Prioridad 2"
                };
            case 3:
                return {
                    btn: "bg-blue-50 border-blue-300 text-blue-700 font-semibold shadow-sm",
                    icon: "fas fa-flag text-blue-600",
                    badge: "bg-blue-600",
                    label: "Prioridad 3"
                };
            default:
                return {
                    btn: showPriority ? "bg-slate-100 border-slate-300 text-slate-700" : "bg-white border-gray-200 text-gray-600 hover:bg-gray-50",
                    icon: "far fa-flag text-gray-400",
                    badge: "",
                    label: "Prioridad"
                };
        }
    };

    const style = getPriorityStyles();

    return (
        <div className="relative" ref={priorityRef}>
            <button
                type="button"
                onClick={() => setShowPriority(!showPriority)}
                className={`px-2.5 py-1.5 rounded-lg border text-xs font-medium flex items-center space-x-1.5 transition-all duration-200 ${style.btn}`}
            >
                <i className={`${style.icon} text-sm transition-colors`}></i>
                <span>{style.label}</span>
                {isConfigured && (
                    <i className={`fas fa-check text-[9px] ${style.badge} text-white rounded-full w-3.5 h-3.5 flex items-center justify-center ml-0.5 animate-fadeIn`}></i>
                )}
            </button>

            {showPriority && (
                <div className="absolute left-0 top-full mt-2 p-2 bg-white border border-gray-200 rounded-lg shadow-xl z-50 w-40 space-y-1 animate-fadeIn">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase p-1">Prioridad</label>
                    <select
                        value={priority}
                        onChange={(e) => {
                            setPriority(Number(e.target.value));
                            setShowPriority(false);
                        }}
                        className="w-full p-1.5 border border-gray-200 rounded text-xs text-gray-700 focus:outline-none bg-white"
                    >
                        <option value="1">🔴 Prioridad 1</option>
                        <option value="2">🟠 Prioridad 2</option>
                        <option value="3">🔵 Prioridad 3</option>
                        <option value="4">⚪ Prioridad 4</option>
                    </select>
                </div>
            )}
        </div>
    );
};
